"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkTokenLogin = exports.checkLogin = void 0;
exports.clipboard = clipboard;
exports.isDev = exports.hasToken = exports.get = exports.default = void 0;
exports.lang = lang;
exports.subscribe = exports.saveToken = exports.saveCookieLogin = exports.saveCookie = exports.removeToken = exports.removeCookieLogin = exports.removeCookie = exports.publish = exports.post = exports.logout = exports.loginPost = exports.login = exports.linkClick = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _universalCookie = _interopRequireDefault(require("universal-cookie"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var USER_ACCESS_TOKEN = 'user_access_token';
var isDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
exports.isDev = isDev;
function l(text) {
  if (isDev) console.log(text);
}
var isLocal = false;
try {
  isLocal = localStorage !== undefined;
} catch (e) {
  isLocal = false;
}

// ---- backend

var _isURL = function _isURL(str) {
  return str.startsWith('/d/') || new RegExp('^https?:\\/\\/', 'i').test(str);
};
var _endPoint = function _endPoint(endpoint) {
  return _isURL(endpoint) ? endpoint : (!!process.env.REACT_APP_BACKEND && _rtrimSlash(process.env.REACT_APP_BACKEND)) + '/' + _trimSlash(endpoint);
};
var _rtrimSlash = function _rtrimSlash(path) {
  return path ? path.replace(/\/$/, '') : '';
};
var _trimSlash = function _trimSlash(path) {
  return path ? path.replace(/^\/|\/$/g, '') : '';
};
var get = function get(endpoint, params, direct) {
  var config = {
    withCredentials: true
  };
  if (params) config.params = params;
  var token = hasToken();
  if (token) config.headers = {
    'Authorization': 'Bearer ' + token
  };
  var url = direct ? endpoint : _endPoint(endpoint);
  l('GET: ' + url);
  return new Promise(function (resolve, reject) {
    return _axios.default.get(url, config).then(function (response) {
      return resolve(response.data);
    }).catch(function (e) {
      return reject({
        code: e.response.status,
        error: e.code,
        message: e.message
      });
    });
  });
};
exports.get = get;
var post = function post(endpoint, data, params, direct) {
  var config = {
    withCredentials: true
  };
  if (params) config.params = params;
  var token = hasToken();
  if (token) config.headers = {
    'Authorization': 'Bearer ' + token
  };
  var url = direct ? endpoint : _endPoint(endpoint);
  l('POST: ' + url);
  return new Promise(function (resolve, reject) {
    return _axios.default.post(url, data, config).then(function (response) {
      return resolve(response.data);
    }).catch(function (e) {
      return reject({
        code: e.response.status,
        error: e.code,
        message: e.message
      });
    });
  });
};

// ---- router
exports.post = post;
var linkClick = function linkClick(e, history) {
  if (!e.ctrlKey) {
    e.preventDefault();
    history.push(e.currentTarget.getAttribute('href'));
  }
};

// ---- socket
exports.linkClick = linkClick;
var publish = function publish(ch, data) {
  return _axios.default.post(process.env.REACT_APP_SUB + ch, data).then(function (response) {
    return response.data;
  }).catch(function (e) {
    return console.log("publish error ".concat(e));
  });
};
exports.publish = publish;
var subscribe = function subscribe(ch, onMessage) {
  var ws = new WebSocket(process.env.REACT_APP_SUB + ch);
  if (onMessage) ws.onmessage = function (e) {
    return onMessage(JSON.parse(e.data));
  };
  ws.onopen = function () {
    return l('WebSocket [open]');
  };
  ws.onclose = function (e) {
    if (e.wasClean) {
      l('WebSocket [close_wasClean] , code=' + e.code + ' reason=' + e.reason);
    } else {
      l('WebSocket [close] Connection died');
      setTimeout(function () {
        return subscribe(ch, onMessage);
      }, 250);
    }
  };
  ws.onerror = function (e) {
    return l('WebSocket [error] ' + e.message);
  };
  return ws;
};

// ---- user
exports.subscribe = subscribe;
var hasToken = function hasToken() {
  return isLocal && localStorage.getItem(USER_ACCESS_TOKEN);
};
exports.hasToken = hasToken;
var saveToken = function saveToken(token) {
  return isLocal && localStorage.setItem(USER_ACCESS_TOKEN, token);
};
exports.saveToken = saveToken;
var removeToken = function removeToken() {
  return isLocal && localStorage.removeItem(USER_ACCESS_TOKEN);
};
exports.removeToken = removeToken;
var saveCookie = function saveCookie(cookies) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var c = new _universalCookie.default();
  for (var key in cookies) {
    if (cookies.hasOwnProperty(key)) {
      c.set(key, cookies[key], _objectSpread({
        path: '/'
      }, option));
    }
  }
};
exports.saveCookie = saveCookie;
var removeCookie = function removeCookie(cookies) {
  var c = new _universalCookie.default();
  for (var x in cookies) {
    if (cookies.hasOwnProperty(x)) {
      c.remove(cookies[x]);
    }
  }
};
exports.removeCookie = removeCookie;
var saveCookieLogin = function saveCookieLogin(token) {
  var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var saved = {};
  saved["__".concat(process.env.REACT_APP_PROJECT, "_g")] = process.env.REACT_APP_GKEY;
  saved["__".concat(process.env.REACT_APP_PROJECT, "_t")] = token;
  saveCookie(saved, option);
};
exports.saveCookieLogin = saveCookieLogin;
var removeCookieLogin = function removeCookieLogin() {
  return removeCookie(["__".concat(process.env.REACT_APP_PROJECT, "_g"), "__".concat(process.env.REACT_APP_PROJECT, "_t")]);
};
exports.removeCookieLogin = removeCookieLogin;
var checkLogin = function checkLogin() {
  var c = new _universalCookie.default();
  if (process.env.REACT_APP_PROJECT !== undefined && c.get("__".concat(process.env.REACT_APP_PROJECT, "_t"))) return checkTokenLogin();
  return checkTokenLogin(hasToken());
};
exports.checkLogin = checkLogin;
var checkTokenLogin = function checkTokenLogin(token, endpoint) {
  return new Promise(function (resolve) {
    var config = {
      withCredentials: true
    };
    if (token) config.headers = {
      'Authorization': 'Bearer ' + token
    };
    return _axios.default.get(_endPoint(!!endpoint ? endpoint : 'login-check'), config).then(function (response) {
      return resolve(response.data);
    }).catch(function (e) {
      return resolve({
        ok: false,
        _exception: e
      });
    });
  });
};
exports.checkTokenLogin = checkTokenLogin;
var login = function login(username, password) {
  return _axios.default.get(_endPoint('login'), {
    withCredentials: true,
    auth: {
      username: unescape(encodeURIComponent(username)),
      password: unescape(encodeURIComponent(password))
    }
  }).then(function (response) {
    return response.data;
  });
};
exports.login = login;
var loginPost = function loginPost(username, password) {
  return _axios.default.post(_endPoint('login'), {
    U: username,
    P: password
  }, {
    withCredentials: true
  }).then(function (response) {
    return response.data;
  });
};
exports.loginPost = loginPost;
var logout = function logout(server) {
  if (server) {
    return _axios.default.get(_endPoint('logout'), {
      withCredentials: true
    }).then(function (response) {
      return response.data;
    }).then(function (d) {
      if (d.ok) {
        removeToken();
        removeCookieLogin();
      }
      return d;
    });
  }
  return new Promise(function (resolve) {
    removeToken();
    removeCookieLogin();
    return resolve(true);
  });
};

// ---- i18n
exports.logout = logout;
var lastLang = 'th';
function lang(lang) {
  if (lang !== undefined && typeof lang === 'string') lastLang = lang;
  return lastLang;
}

// ---- utils

function clipboard(text) {
  if (navigator.clipboard) return navigator.clipboard.writeText(text);
}
var _default = {
  isDev: isDev,
  get: get,
  post: post,
  linkClick: linkClick,
  publish: publish,
  subscribe: subscribe,
  checkLogin: checkLogin,
  checkTokenLogin: checkTokenLogin,
  login: login,
  logout: logout
};
exports.default = _default;